/* Printhia — auto-rotácia obrázkov na kartách produktov (len vo viewporte) */
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var DELAY = 2600;
  function init(){
    var wraps = document.querySelectorAll('.media--hover-effect.printhia-rotate');
    Array.prototype.forEach.call(wraps, function(wrap, wi){
      if (wrap.dataset.rotateInit) return;
      var overlays = Array.prototype.slice.call(wrap.querySelectorAll('.printhia-rotate__img'));
      if (!overlays.length) return;
      wrap.dataset.rotateInit = '1';
      var frames = overlays.length + 1, idx = 0, timer = null;
      function step(){
        idx = (idx + 1) % frames;
        overlays.forEach(function(im, i){ im.classList.toggle('is-active', i === idx - 1); });
      }
      function start(){ if (!timer) timer = setInterval(step, DELAY + (wi % 4) * 250); }
      function stop(){ if (timer){ clearInterval(timer); timer = null; } idx = 0; overlays.forEach(function(im){ im.classList.remove('is-active'); }); }
      if ('IntersectionObserver' in window){
        new IntersectionObserver(function(es){
          es.forEach(function(e){ e.isIntersecting ? start() : stop(); });
        }, { rootMargin: '150px' }).observe(wrap);
      } else { start(); }
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
